<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display: flex;justify-content: flex-start;align-items: center;">
        <button-add :pathName="addAccountRouterName" :value="addBtnValue" v-if="permissionCodes.indexOf('004018001') !== -1"/>
      </div>
      <input-select selectTitle="用户是否可自购" :selectKey="'saleForMobile'" :selectData="saleForMobileList" @search="search"/>
      <input-search :placeholder="searchPlaceholder" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSwitch="changeSwitch" @deleteLine="deleteLine" @goToModifyPage="goToModifyPage" :deleteTipInfo="deleteTipInfo" :operationArr="operationArr" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" />
  </div>
</template>

<script>
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../../components/Button/ButtonAdd";
import InputSearch from "../../../../components/Input/InputSearch";
import TableMain from "../../../../components/Table/TableMain";
import { api } from "../../../api/ParkingService";
import { errorHandler } from "../../../../utils/errorHandler";
import { nSuccess } from "../../../../utils/notice";
import { bus } from "../../../../utils/bus";
import ButtonCancel from "../../../../components/Button/ButtonCancel";
import InputSelect from "../../../../components/Input/InputSelect";

export default {
  components: {
    InputSelect,
    ButtonCancel,
    TableMain,
    InputSearch,
    ButtonAdd,
    Breadcrumb
  },
  name: "coupon-put-on-the-shelves",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "上架优惠券"
        }
      ],
      addAccountRouterName: "coupon-put-on-the-shelves-add",
      addBtnValue: "上架优惠券",
      searchPlaceholder: "优惠券名称",
      searchKey: "",
      saleForMobile: '',
      deleteTipInfo: "是否确认删除该优惠券？",
      saleForMobileList: [
        {key: "", label: "全部"},
        {key: true, label: "是"},
        {key: false, label: "否"}
      ],
      tableHead: [
        {
          prop: "name",
          label: "优惠券名称"
        },
        {
          prop: "type",
          label: "优惠券类型"
        },
        {
          prop: "denomination",
          label: "优惠券面额"
        },
        {
          prop: "num",
          label: "优惠券张数"
        },
        {
          prop: 'saleForMobile',
          label: '用户是否可自购',
          width: '160',
          isSwitch: true
        },
        {
          prop: "price",
          label: "优惠券售价(元)"
        },
        {
          prop: "couponTimeValue",
          label: "优惠券有效期",
          width: "280"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      operationArr: ["modify", "delete"]
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    getPage() {
      this.$axios
        .post(api.parkingCouponIssueGetPage, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          searchKey: this.searchKey,
          saleForMobile: this.saleForMobile
        })
        .then(res => {
          if (res.data.retCode === 1) {
            this.total = res.data.data.total;
            let data = res.data.data.list;
            data.map(v => {
              if (v.type === "金额") {
                v.denomination = `${v.denominationMoney}元`;
              } else {
                if (!v.denominationHour) {
                  v.denomination = `${v.denominationMinite}分钟`;
                } else {
                  v.denomination = `${
                    v.denominationHour
                  }小时${v.denominationMinite || 0}分钟`;
                }
              }
              if (v.startTime) {
                v.couponTimeValue = `${v.startTime}至${v.endTime}`;
              } else {
                v.couponTimeValue = ''
              }
            });
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取信息失败"));
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.searchKey = v;
      this.getPage();
    },
    search(v) {
      this.pageNum = 1;
      this[v.key] = v.value;
      this.getPage();
    },
    // 修改
    goToModifyPage(code) {
      this.$router.push({
        path: `/park_server/coupon_put_on_the_shelves_modify/${code}`
      });
    },
    // 删除
    deleteLine(code) {
      this.$axios
        .post(api.parkingCouponIssueDeleteByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.getPage();
          }
        })
        .catch(errorHandler("删除失败"));
    },

    changeSwitch (data) {
      this.$confirm('是否确认修改该用户自购状态？', '温馨提示')
        .then(() => {
          for (let i in data) {
            if (data[i] === '--') {
              data[i] = ''
            }
          }
          this.$axios.post(api.parkingCouponIssueUpdate, data)
            .then(res => {
              nSuccess('修改成功')
              this.getPage()
            })
            .catch(errorHandler('修改失败'))
        })
        .catch(() => {
          this.getPage()
        })
    },
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingCoupon/CouponPutOnTheShelves/CouponPutOnTheShelves.vue